module.exports = __webpack_public_path__ + "img/check.3848682e.png";